module.exports = __webpack_public_path__ + "img/iphone_frame.15766641.png";